import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhPackage } from 'ember-phosphor-icons';

export interface RecentApplicationsEmptySignature {
  Element: HTMLDivElement;
}

const RecentApplicationsEmpty: TOC<RecentApplicationsEmptySignature> = <template>
  <div class="tio-place-center py-16 pb-20" ...attributes>
    {{! Icon - using PhPackage as placeholder, similar to DropboxLogo shape }}
    <div class="mb-2">
      <PhPackage @size={{40}} class="tio-fg-disabled" />
    </div>

    {{! Text content }}
    <div class="tio-stack-center gap-1 text-center">
      <h3 class="tio-text-lg-semibold tio-fg-primary tracking-wide">
        {{t "tas.dashboard.no_applications_title"}}
      </h3>
      <p class="text-base tio-fg-muted max-w-sm">
        {{t "tas.dashboard.no_applications_description"}}
      </p>
    </div>
  </div>
</template>;

export default RecentApplicationsEmpty;
